import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { ResolveThunks, connect, useSelector } from "react-redux";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Img from "@insite/mobius/Img";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import translate from "@insite/client-framework/Translate";

const enum fields {
    telNo = "telNo",
}

const mapStateToProps =  (state: CustomApplicationState) => {
    const billToId = state.context.session.billToId;
    let livechat_accountNumber;
    if (billToId) {
        livechat_accountNumber = state.data.billTos.byId[billToId]?.customerNumber
    }
    return {
        session: state.context.session,
        liveChatURL: getSettingsCollection(state).customerSettings.liveChatURL,
        livechat_firstName: state.context.session.firstName,
        livechat_lastName: state.context.session.lastName,
        livechat_email: state.context.session.email,
        livechat_accountNumber,
    };
};


interface CustomProps extends WidgetProps {
    fields: {
        [fields.telNo]: string;
    };
}

const mapDispatchToProps = {toggleLoginDrawer, };

type Props = WidgetProps &
    CustomProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> ;



export interface rewardsBannerStyles{
    bannerImage?: InjectableCss;
    bannerHeader?: InjectableCss;
    subHeading?: InjectableCss;
    bannerlogo?: InjectableCss;
    description?: InjectableCss;
    activationLink?: InjectableCss;
    homePageChatNowHeadingText?: InjectableCss;
    bannerText?: InjectableCss;
    bannerSignin?: InjectableCss;
    chatLink?: InjectableCss;
    rewardsChat?: InjectableCss;
    rewardsChatmain?: InjectableCss;
    rewardsChatmain2?: InjectableCss;
    rewardsChatmainsection?: InjectableCss;
    rewardsChatmainone?: InjectableCss;
    bannerImageStyle?: InjectableCss;
}

export const rewardsBannerStyles: rewardsBannerStyles = {
    bannerImageStyle: {
        css: css`
            @media (max-width: 767px) {
                display: none;
            }
        `,
    },
    bannerImage: {
        css: css`
            position: relative;
            @media only screen and (min-width: 768px) and (max-width: 1079px) {
                height: 375px !important;
                flex: 0 0 100%;
                max-width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-flow: row wrap;
                align-items: stretch;
                background-image: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/landing_pages/rewards/hero-banner-rewards.jpg);
                height: 375px !important;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
            }
            @media (max-width: 767px) {
                background-image: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/landing_pages/rewards/hero-banner-rewards.jpg);

                display: flex;
                justify-content: space-between;
                position: relative;
                padding: 40px 70px;
                background-size: cover !important;
                background-position: 50% 40% !important;

                height: 380px;
            }
            Img {
                width: 100%;
            }
        `,
    },
    bannerText: {
        css: css`
            position: absolute;
            top: 70px;
            left: 170px;
            max-width: 520px;
            @media only screen and (min-width: 768px) and (max-width: 1079px) {
                left: 100px;
            }
            @media (max-width: 767px) {
                left: 30px;
                height: 375px;
            }
        `,
    },
    bannerlogo: {
        css: css`
            > Img {
                width: 162px;
                height: 43px;
            }
        `,
    },
    bannerHeader: {
        css: css`
            font-family: Nunito Sans;
            font-size: 40px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.15;
            letter-spacing: normal;
            text-align: left;
            color: #002856;
            margin: 10px 0 10px 0;
            @media (max-width: 767px) {
                font-size: 32px;
            }
        `,
    },
    subHeading: {
        css: css`
            font-family: Nunito Sans;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #2d2926;
            padding: 0px 0px 30px 0px;
            margin: 0px;
            @media (max-width: 767px) {
                font-size: 14ppx;
            }
        `,
    },
    bannerSignin: {
        css: css`
            font-family: Nunito Sans;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #fff !important;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 10px;
            padding: 10px;
            border-radius: 4px;
            background-color: #006ae3;
            width: 190px;
            height: 40px;
            > span {
                color: #fff !important;
            }
        `,
    },
    activationLink: {
        css: css`
            font-family: Nunito Sans;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #fff;
            width: 190px;
            height: 40px;
            flex-grow: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 10px;
            padding: 10px;
            border-radius: 4px;
            background-color: #006ae3;
            > span {
                color: #fff !important;
            }
        `,
    },
    rewardsChatmainsection: {
        css: css`
            @media only screen and (min-width: 768px) and (max-width: 1079px) {
                margin-top: 20px;
            }
            @media (max-width: 767px) {
                margin-top: 20px;
                font-size: 16px;
            }
        `,
    },
    rewardsChatmain: {
        css: css`
            min-height: 55px;
            height: auto;
            padding: 30px 80px 0px 30px;
            @media (max-width: 767px) {
                padding: 10px;
                font-size: 16px;
            }
            border-radius: 4px;
            background-color: #d0dce8;
            width: 100%;
            font-family: Nunito Sans;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #2d2926;
        `,
    },
    rewardsChatmainone: {
        css: css`
            min-height: 55px;
            height: auto;
            padding: 30px 80px 30px 30px;
            @media (max-width: 767px) {
                padding: 10px;
                font-size: 16px;
            }
            border-radius: 4px;
            background-color: #d0dce8;
            width: 100%;
            font-family: Nunito Sans;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #2d2926;
        `,
    },
    rewardsChatmain2: {
        css: css`
            min-height: 55px;
            padding: 0px 80px 30px 30px;
            @media (max-width: 767px) {
                padding: 10px;
                font-size: 16px;
            }
            height: auto;

            border-radius: 4px;
            background-color: #d0dce8;
            width: 100%;
            font-family: Nunito Sans;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #2d2926;
        `,
    },
    chatLink: {
        css: css`
            color: #006ae3;
            padding: 0 5px;
            text-decoration: underline;
            cursor: pointer;
        `,
    },
};

export const ADIProRewards: FC<Props>  = ({ session, liveChatURL, livechat_firstName,
    livechat_lastName, livechat_accountNumber, livechat_email,fields,toggleLoginDrawer}: Props) => {
        const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
        const userloyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.loyaltyRewardUserStore);
        const userRoles = useSelector((state:CustomApplicationState) => state.context.session.userRoles)
        const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
        const styles = rewardsBannerStyles;
        const telNumber="tel:"+fields.telNo;
        const onClickSignIn = () => {
            toggleLoginDrawer({ loginDrawer: true });
        };
        const accNoLTY=userloyaltyState.user.userId!= undefined ? userloyaltyState.user.userId: ""
        const accNoSession=livechat_accountNumber?.toString().split('-')[0];
        const userNameSession= useSelector((state:CustomApplicationState) => state.context.session.userName?.toLocaleLowerCase());
        const emailLTY= userloyaltyState.user.email!= undefined ? userloyaltyState.user.email?.toLocaleLowerCase() : ""
        const emailLoyalty= userloyaltyState.user.email!= undefined ? userloyaltyState.user.email: ""
        const invitedUser=(accNoLTY==accNoSession && userloyaltyState.user.isEnrolled==false && userNameSession==emailLTY && 
            !isProRewardsUser && 
            (userloyaltyState.user.status?.toLocaleUpperCase()=="A" || 
            userloyaltyState.user.status?.toLocaleUpperCase()=="B" ||
            userloyaltyState.user.status?.toLocaleUpperCase()=="O")
            );
        const anotherUserInvited=(accNoLTY==accNoSession && userloyaltyState.user.isEnrolled==false && userNameSession!=emailLTY && 
            !isProRewardsUser && 
            (userloyaltyState.user.status?.toLocaleUpperCase()=="A" || 
            userloyaltyState.user.status?.toLocaleUpperCase()=="B" ||
            userloyaltyState.user.status?.toLocaleUpperCase()=="O")
            ); 
        const anotherUserEnrolled=(accNoLTY==accNoSession && userloyaltyState.user.isEnrolled==true && userNameSession!=emailLTY && 
            !isProRewardsUser && 
            (userloyaltyState.user.status?.toLocaleUpperCase()=="A" || 
            userloyaltyState.user.status?.toLocaleUpperCase()=="B" ||
            userloyaltyState.user.status?.toLocaleUpperCase()=="O")
            );
        const openChat = () => {
            const popup: string = 'popUpWindow';
            const popupParam: string = 'height=551,width=344,left=100,top=100,resizable=false,scrollbars=false,toolbar=false,menubar=no,location=no,directories=no,status=yes';
            if (liveChatURL && isAuthenticated) {
                const result = liveChatURL
                    + 'firstName=' + livechat_firstName
                    + '&lastName=' + livechat_lastName
                    + '&accountNumber=' + livechat_accountNumber?.toString().replace('-', '')
                    + '&email=' + livechat_email
                window.open(result, popup, popupParam);
            }
        }
        const AlertModuleWrapper = styled.span`
                text-align: center;
                border-radius: 4px;

                @media screen and (max-width: 820px) {
                    margin: 0px 5px;
                }
            `;
            const Links = styled.a`
                text-decoration: underline;
                cursor: pointer;
                color: #006AE3;

                &:hover {
                    color: #004DA6;
                }
            `;

    return (
    <>
<StyledWrapper {...styles.rewardsChatmainsection}>
        
        {!invitedUser && !anotherUserInvited && !anotherUserEnrolled && isAuthenticated && (
                    <StyledWrapper>
                        <Typography as={"p"} {...styles.rewardsChatmainone}>
                            {translate("For more information about ADI Pro Rewards program enrollment,")}
                            <Link as="p" {...styles.chatLink} onClick={openChat}>
                                {" "}
                                {translate("chat")}{" "}
                            </Link>
                            {translate("with us from 8 a.m. to 7 p.m. ET or call us at ")}
                            <AlertModuleWrapper>
                                <Links href={telNumber}>{fields.telNo}</Links>.
                            </AlertModuleWrapper>
                        </Typography>
                    </StyledWrapper>
                )}
        

        {anotherUserInvited && isAuthenticated && (
                    <StyledWrapper>
                        <Typography as="p" {...styles.rewardsChatmain}>
                            {translate(
                                "Another user on this account has been invited as the designated rewards owner but has not yet enrolled in the program",
                            )}
                         
                        </Typography>
                        <Typography as="p" {...styles.rewardsChatmain2}>
                            {translate("Need to request a change or have questions?")}
 
                            <Link as="p" {...styles.chatLink} onClick={openChat}>
                                {translate("chat")}
                            </Link>
                            {translate("with us from 8 a.m. to 7 p.m. ET or call us at ")}
                            <AlertModuleWrapper>
                                <Links href={telNumber}>{fields.telNo}</Links>.
                            </AlertModuleWrapper>
                        </Typography>
                    </StyledWrapper>
                )}
        {anotherUserEnrolled && isAuthenticated && (
                    <StyledWrapper>
                        <Typography as={"p"} {...styles.rewardsChatmain}>
                            <Typography style={{ fontWeight: 700, textDecoration: "underline" }}>
                                {" "}
                                {emailLoyalty}
                            </Typography>{" "}
                            {translate(
                                "has already enrolled in the program as the designated rewards owner for this account.",
                            )}
                        </Typography>
 
                        <Typography as="p" {...styles.rewardsChatmain2}>
                            {translate("Need to request a change or have questions?")}
                            <Link as="p" {...styles.chatLink} onClick={openChat}>
                                {" "}
                                {translate("chat")}{" "}
                            </Link>
                            {translate("with us from 8 a.m. to 7 p.m. ET or call us at ")}
                            <AlertModuleWrapper>
                                <Links href={telNumber}>{fields.telNo}</Links>.
                            </AlertModuleWrapper>
                        </Typography>
                    </StyledWrapper>
                )}
</StyledWrapper>
</>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIProRewards),
    definition: {
        group: "Basic",
        icon: "PageTitle",
        displayName: "LTY message for AdiProRewards Landing page",
        fieldDefinitions: [
            {
                name: fields.telNo,
                displayName: "Telephone Number",
                editorTemplate: "TextField",
                defaultValue: "877.228.6739",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
